import styled from '@emotion/styled';
import { Colors } from '../../../colors';
export const TooltipStyled = {
  ContainerTooltip: styled.div<any>`
    background-color: ${Colors.White};
  `,
  TitleTooltip: styled.span<any>`
    font-family: EncodeSans-Medium;
    font-size: 12px;
    color: ${Colors.Black};
    margin-bottom: 5px;
  `,
  DescriptionTooltipContainer: styled.div<any>`
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding: 5px 0px;

  `,
  DescriptionTooltipText: styled.p<any>`
    font-family: EncodeSans-Medium;
    font-size: 10px;
    color: ${Colors.UnderlinedGrey}
   
  `,
  ContainerIconRight: styled.div<any>`
    margin-left: 6px;
    padding-top: 1px;
  `,
  ContainerRadios: styled.div<any>`
    display: flex; 
    align-items: center;
    margin-right: 60px;
  `,
};


